import { MatDialogConfig } from '@angular/material/dialog';

export const CustomMatDialogConfig: MatDialogConfig = {
  autoFocus: false,
  minHeight: '25.6rem',
  minWidth: '46rem',
};